/**
 * @generated SignedSource<<58a2cca5ecdc5914fe6302fa7d92ab83>>
 * @relayHash c9f58df38efe000a4308cf37e9e410f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8496a2e8b9b8f274848b5a28922ec7628aa08f5f27906dc8ed807a947ec4a86c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProjectDirectoryLayoutQuery } from './ProjectDirectoryLayoutQuery.graphql';

import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: PreloadableConcreteRequest<ProjectDirectoryLayoutQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8496a2e8b9b8f274848b5a28922ec7628aa08f5f27906dc8ed807a947ec4a86c",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
    }
  }
};

export default node;
